module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsEAAA7BAbiRa+0AAACPSURBVFhHY/z//z8DKeBWjfct+f+vVKFcdFDO3nq6C8omCjBB6QEDow4YdcCoA0YdMOAOYPxRZVIGZRMFvjGw13Ix/OSBctHBFCB+DGESB0AOIK0yoDIYTQOjDhh1wMCXA6NtQig9YGDUAaMOGHXAqANILop/Vpuq/GNgDIZyUQATw/+1wKL4DpRLBGBgAAB2aC0PGMddDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/content/ExpandIcon.png
// module id = 656
// module chunks = 0